export default {
	ADD_MESSAGE: (state, message) => {
		state.messages.push(Object.assign({
			type: 'error',
			message: 'unknown',
			locale: true,
			show: true
		}, message))
	},

	REMOVE_MESSAGE: (state, messageId) => {
		state.messages = state.messages.filter(message => message.id != messageId)
	},

	SET_TARIFFS: (state, tariffs) => {
		state.tariffs = tariffs
	},

	SET_OPTIONS: (state, options) => {
		const optionClassIgnore = ['preorder']

		state.options = options.filter(it => !optionClassIgnore.includes(it.code))
	},

	SET_ORDER_DATA: (state, order) => {
		state.order = order
		localStorage.order = JSON.stringify(order)
	},

	CHANGE_REVERSE_INDEX: (state, value) => {
		state.reverseIndex = value
	},

	SET_REVERSE_DATA: (state, data) => {
		state.reverseData = data
	}
}
